import { gql } from 'apollo-boost';

const updateHardwareGQL = gql`
  mutation hardware(
    $id: String
    $name: String
    $serialNumber: String
    $os: String
    $appleID: String
    $type: String
    $comments: String
    $location: String
  ) {
    updateHardware(
      hardware: {
        id: $id
        name: $name
        serialNumber: $serialNumber
        os: $os
        appleID: $appleID
        type: $type
        comments: $comments
        location: $location
      }
    ) {
      id
      name
      serialNumber
      os
      appleID
      type
      comments
      timestamp
      location
    }
  }
`;

export default updateHardwareGQL;
